import { makeStyles } from '@mui/styles';

const adminStyles = makeStyles(theme => ({
	adminButton: {
		color: '#000 !important',
		backgroundColor: '#93FF50 !important',
	},
	topSpace: {
		marginTop: '30px !important',
	},
	buttonDisabled: {
		border: 'none',
    	backgroundColor: 'transparent',
    	color: '#000',
	},
	buttonActive: {
		width: '70px',
		height: '30px',
		cursor: 'pointer',
		backgroundColor: '#4672D5',
		color: '#fff',
		border: '1px solid #4672D5',
		borderRadius: '3px',
	},
	buttonInactive: {
		width: '70px',
		height: '30px',
		cursor: 'pointer',
		backgroundColor: '#fff',
		color: '#4672D5',
		border: '1px solid #fff',
	},
	grade: {
		borderRadius: '3px',
		backgroundColor: '#00f',
		width: '23px',
		textAlign: 'center',
		height: '23px',
		lineHeight: '23px',
		fontWeight: 700,
		display: 'inline-block',
		marginLeft: '5px',
		color: '#fff',
		verticalAlign: 'top',
		cursor: 'pointer',
	},
	gradeArrow: {
		display: 'none',
		width: '20px',
		height: '20px',
	},
	gradeArrowSelected: {
		display: 'block',
		width: '20px',
		height: '20px',
		marginLeft: '2px',
	},
}));

export default adminStyles;